var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4194,
    cy: 30.1562,
    r: 28.6451,
    fill: "white",
    stroke: "#454551",
    strokeWidth: 1.39732
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7409 45.1775H22.097C18.1845 45.1775 15.6973 42.8439 15.4737 38.9454L14.7471 27.4175C14.6353 25.6709 15.2362 23.9941 16.4379 22.7225C17.6256 21.4509 19.3024 20.7243 21.035 20.7243C21.4822 20.7243 21.9154 20.4589 22.125 20.0397L23.131 18.0415C23.9554 16.4066 26.0235 15.1351 27.826 15.1351H31.0259C32.8284 15.1351 34.8825 16.4066 35.7069 18.0275L36.713 20.0676C36.9226 20.4589 37.3418 20.7243 37.8029 20.7243C39.5356 20.7243 41.2124 21.4509 42.4001 22.7225C43.6018 24.008 44.2026 25.6709 44.0908 27.4175L43.3642 38.9594C43.1127 42.9138 40.6954 45.1775 36.7409 45.1775ZM27.826 17.231C26.792 17.231 25.4785 18.0415 25.0034 18.9777L23.9974 20.9898C23.4105 22.1217 22.2787 22.8203 21.035 22.8203C19.8613 22.8203 18.7714 23.2954 17.9609 24.1478C17.1645 25.0001 16.7592 26.118 16.8431 27.2778L17.5697 38.8197C17.7374 41.6422 19.2604 43.0815 22.097 43.0815H36.7409C39.5635 43.0815 41.0866 41.6422 41.2683 38.8197L41.9949 27.2778C42.0647 26.118 41.6735 25.0001 40.877 24.1478C40.0666 23.2954 38.9766 22.8203 37.8029 22.8203C36.5593 22.8203 35.4275 22.1217 34.8406 21.0178L33.8205 18.9777C33.3594 18.0555 32.0459 17.245 31.0119 17.245H27.826V17.231Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5153 25.615H27.3234C26.7505 25.615 26.2754 25.1399 26.2754 24.567C26.2754 23.9941 26.7505 23.519 27.3234 23.519H31.5153C32.0882 23.519 32.5633 23.9941 32.5633 24.567C32.5633 25.1399 32.0882 25.615 31.5153 25.615Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4194 39.5882C26.3313 39.5882 23.8301 37.087 23.8301 33.9989C23.8301 30.9108 26.3313 28.4096 29.4194 28.4096C32.5074 28.4096 35.0086 30.9108 35.0086 33.9989C35.0086 37.087 32.5074 39.5882 29.4194 39.5882ZM29.4194 30.5056C27.4911 30.5056 25.9261 32.0706 25.9261 33.9989C25.9261 35.9272 27.4911 37.4922 29.4194 37.4922C31.3477 37.4922 32.9127 35.9272 32.9127 33.9989C32.9127 32.0706 31.3477 30.5056 29.4194 30.5056Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.83a46047a1c9af3fd8616db0b2e2622d.svg";
export { ForwardRef as ReactComponent };